import React from 'react';
import DocumentMeta from 'react-document-meta';
import { Link, useHistory } from 'react-router-dom';
import Cart from '../components/Cart';
import useCart from '../hooks/useCart';
import styles from '../styles/CartPage.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const CartPage = () => {
  const history = useHistory();
  const {
    items,
    changeQuantity,
    removeItem,
  } = useCart();

  return (
    <DocumentMeta
      title="Shopping cart | Grain Bites"
      description="Review your Grain Bites bread and pastry order."
    >
      <main className={styles.page}>
        <header className={styles.hero}>
          <p className={styles.eyebrow}>Grain Bites shop</p>
          <h1>Your shopping cart</h1>
          <p>Review your fresh bread and pastry selection before placing an order.</p>
        </header>

        <section className={styles.content} aria-label="Shopping cart">
          <div className={styles.cartWrap}>
            <Cart
              items={items}
              onChangeQuantity={changeQuantity}
              onRemove={removeItem}
              onCheckout={() => history.push(`${publicUrl}/PlaceOrder`)}
            />
          </div>
          <Link className={styles.back} to={`${publicUrl}/Shop`}>
            Continue shopping
          </Link>
        </section>
      </main>
    </DocumentMeta>
  );
};

export default CartPage;
